theme.cartTemplate = {};
var BTCartPage = {
	selectors: {
		content: '.cart-page__content',
		updateAllBtn: '.cart__update__all',
		qtyInput: '.cart__qty-input',
		crosssell: {
      wrap: '.cart-page__cross_sell',
      content: '.cart-page__cross_sell__content'
    },
    itemsTable: '.cart-page__items-table',
    countdown: '.cart-countdown'
	},

	data: {
		item_size: 0
	},

	initCartEvent: function() {
		var ins = this;
		$(document).on('ajaxCart.afterCartLoad', function() {
			BT.callAjax(theme.cartUrl, 'GET', {section_id: theme.cartTemplate.sectionId}, null, function(html) {
				$(ins.selectors.content).html($(ins.selectors.content, html).html());
        BT.convertCurrencySilence(ins.selectors.content + ' span.money');
        var oldItemSize = ins.data.item_size;
        ins.updateItemSize();
        if(oldItemSize != ins.data.item_size) {
          $(document).trigger('onReloadCrosssell');
        }
				if (window.Shopify && Shopify.StorefrontExpressButtons) {
	        Shopify.StorefrontExpressButtons.initialize();
	      }
        BT.resetCartTerms();
        if(ins.data.item_size == 0 && $(ins.selectors.countdown).length > 0) {
          $(ins.selectors.countdown).addClass('hide');
          BT.setCookie('countdown_reverse_cart-page',null);
        }
	      if($('#shipping-calculator').length > 0 && "undefined" != typeof Shopify.Cart && "undefined" != typeof Shopify.Cart.ShippingCalculator) {
          Shopify.Cart.ShippingCalculator.show( {
            submitButton: theme.strings.shippingCalcSubmitButton,
            submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
            customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
            moneyFormat: theme.strings.shippingCalcMoneyFormat                                     
          });
        }
        BT.convertProgressBar();
			});
		});

		$(document).on('click', this.selectors.updateAllBtn, function(e) {
			e.preventDefault();
			BT.showLoadingFull();
      var ajaxData = {};
			var updateData = [];
			$(ins.selectors.qtyInput).each(function() {
				updateData.push($(this).val());
			});
      ajaxData.updates = updateData;
      if($('#CartSpecialInstructions').length > 0) {
        ajaxData.note = $('#CartSpecialInstructions').val();
      }
      BT.callAjax(theme.cartUpdateUrl, 'POST', ajaxData, 'json', function(response) {
				BT.updateHeaderCartHtml(true);
				BT.hideLoadingFull();
			});
		});
	},

  updateItemSize: function() {
    var table = $(this.selectors.itemsTable);
    if(table.length > 0) {
      this.data.item_size = table.find('tbody .cart__row').length;
    } else {
      this.data.item_size = 0;
    }
  },

	init: function() {
		this.initCartEvent();
	}
}

theme.CartTemplateSection = (function() {
  function CartTemplateSection(container) {
    theme.cartTemplate.sectionId = $(container).attr('data-section-id');
  	BTCartPage.updateItemSize();
    BT.initDealCountdown('.cart-countdown');
  }
  return CartTemplateSection;
})();

theme.CartTemplateSection.prototype = _.assignIn({}, theme.CartTemplateSection.prototype, {
  onLoad: function(evt) {
    if($('.cart-countdown').length > 0) {
      BT.setCookie('countdown_reverse_cart-page',null);
      BT.initDealCountdown('.cart-countdown');
    }
  }
});

BTCartPage.init();
theme.sections.constructors['cart-template'] = theme.CartTemplateSection;